export type LiveContentStatus = 'COMPLETED' | 'LIVE' | 'UPCOMING';
export const LIVE_CONTENT_STATUS_COMPLETED: LiveContentStatus = 'COMPLETED'; // Content that has already aired and finished
export const LIVE_CONTENT_STATUS_LIVE: LiveContentStatus = 'LIVE'; // Content that is currently live
export const LIVE_CONTENT_STATUS_UPCOMING: LiveContentStatus = 'UPCOMING'; // Content that will start in the future

export const LIVE_GRID_CHANNELS_TO_FETCH: number = 200; // Same as the max number of channels per page that Hodor returns

export const LIVE_GRID_MINIMUM_CONTENT_VIRTUALISATION = 20; // Minimal number of element allowed to have virtualisation
